// ** Icon Imports
import { Icon } from '@iconify/react';

const IconifyIcon = ({ icon, ...rest }) => {
  return <Icon fontSize="1.375rem" icon={icon} {...rest} />;
};

export default IconifyIcon;
